import React from 'react';
import { ShieldCheck } from 'lucide-react';
export const Guarantee = () => {
  return <section className="py-10 md:py-16 bg-white" data-id="element-135">
      <div className="max-w-4xl mx-auto px-4" data-id="element-136">
        <div className="bg-teal text-white rounded-2xl md:rounded-3xl p-6 md:p-12 flex flex-col md:flex-row items-center gap-4 md:gap-8 text-center md:text-left shadow-xl relative overflow-hidden" data-id="element-137">
          <div className="absolute -right-10 -top-10 opacity-10" data-id="element-138">
            <ShieldCheck className="w-48 h-48 md:w-64 md:h-64" data-id="element-139" />
          </div>

          <div className="flex-shrink-0 relative z-10" data-id="element-140">
            <div className="bg-white text-teal w-16 h-16 md:w-24 md:h-24 rounded-full flex items-center justify-center shadow-lg" data-id="element-141">
              <ShieldCheck className="w-8 h-8 md:w-12 md:h-12" data-id="element-142" />
            </div>
          </div>

          <div className="relative z-10" data-id="element-143">
            <h2 className="text-xl md:text-3xl font-extrabold mb-2 md:mb-4" data-id="element-144">
              7 DÍAS GARANTÍA TOTAL
            </h2>
            <h3 className="text-sm md:text-xl font-semibold mb-2 md:mb-4 text-teal-light" data-id="element-145">
              Probalo o te devolvemos el 100%
            </h3>
            <p className="text-white/90 leading-relaxed text-xs md:text-base mb-2 md:mb-4" data-id="element-146">
              Abrís los tomos, probás los bonos en tu próxima visita. Si no es
              lo que esperabas: sin preguntas, sin formularios, sin drama.
            </p>
            <p className="text-[10px] md:text-sm font-medium text-teal-light" data-id="element-147">
              (Tasa de devoluciones &lt; 1%)
            </p>
          </div>
        </div>
      </div>
    </section>;
};